import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Home from '~/pages/Home';
import Article from '~/pages/Article';
import Map from '~/pages/Map';
import Service from '~/pages/Service';
import Downloads from '~/pages/Downloads';
import Help from '~/pages/Help';

import Route from './route';
// import Metadados from '~/pages/Metadados';
import Media from '~/pages/Media';

const Routes = () => (
	<BrowserRouter basename="/geoportal">
		<Route path="/" component={Home} exact />
		<Route path="/article" component={Article} exact />
		<Route path="/article/:id" component={Article} exact />
		<Route path="/map" component={Map} />
		<Route path="/downloads" component={Downloads} exact />
		<Route path="/downloads/:downloadType" component={Downloads} exact />
		{/* <Route path="/metadados" component={Metadados} exact /> */}
		<Route path="/services" component={Service} exact /> 
		<Route path="/help" component={Help} />
		<Route path="/media" component={Media} />
	</BrowserRouter>
);

export default Routes;
